import Alert from 'ant-design-vue/es/alert'
import Button from 'ant-design-vue/es/button'
import Drawer from 'ant-design-vue/es/drawer'
import Form from 'ant-design-vue/es/form'
import Input from 'ant-design-vue/es/input'

const components = [Alert, Button, Drawer, Form, Input]

export const configureAntDesign = (app) => {
  components.forEach((component) => app.use(component))
}
